import React, { useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Checkbox,
    Box,
    useMediaQuery,
    useTheme,
    Drawer,
    IconButton,
    Typography
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";
import { CloseRounded } from "@mui/icons-material";
import { ClipLoader } from "react-spinners";

const MultiPartFormPopup = ({ open, onClose, community, creators = [], communityName = "", onCompleted }) => {
    const [formData, setFormData] = useState({
        community: community,
        title: "",
        description: "",
        mediaUrl: null, // image to upload
        creator: "", // dropdown
        redirectUrl: "", // https URL
        redirectType: "inside", // outside/inside
        redirectId: "", // event ID if any
        idType: "", // type (Event or empty)
        position: ""
    });

    const [notifyUsers, setNotifyUsers] = useState(false)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [loading, setLoading] = useState(false)



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, mediaUrl: e.target.files[0] }));
    };

    const isValidNumber = (value) => {
        return !isNaN(value) && !isNaN(parseFloat(value));
    };


    const handleSubmit = async () => {

        if (isValidNumber(formData.position)) {
            const data = new FormData();
            data.append("community", formData.community);
            data.append("title", formData.title);
            data.append("description", formData.description);
            data.append("creator", formData.creator);
            data.append("redirectUrl", formData.redirectUrl);
            data.append("redirectType", formData.redirectType === "none" ? "outside" : formData.redirectType);
            data.append("redirectId", formData.redirectId);
            data.append("idType", formData.idType);
            data.append("notify", `${notifyUsers}`)
            data.append("position", formData.position)

            // Ensure mediaUrl is a File object before appending
            if (formData.mediaUrl instanceof File) {
                data.append("media", formData.mediaUrl, formData.mediaUrl.name);
            } else {
                console.warn("mediaUrl is not a valid file");
            }

            for (let [key, value] of data.entries()) {
                console.log(`${key}:`, value);
            }




            try {
                setLoading(true)
                const token = localStorage.getItem("token");
                const response = await fetch(`${BASE_URL}/community/noticeboard/create`, {
                    method: "PUT",
                    headers: {
                        "auth-token": token,  // ✅ Do NOT set Content-Type manually
                    },
                    body: data
                });

                const json = await response.json();
                console.log(json);

                if (json.success === true) {
                    alert("Noticeboard updated successfully!");
                    onCompleted()
                } else {
                    alert(`${json.response}`);
                }

                setLoading(false)

            } catch (error) {
                setLoading(false)
                console.error("Submission error:", error);
                alert("Error sharing data in noticeboard!");
            }
        } else {
            alert("Please enter a valid number in position")
        }
    };


    return (
        <Drawer
            anchor={isMobile ? "bottom" : "right"}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 420,
                    height: isMobile ? "85vh" : "100vh",
                    borderRadius: isMobile ? "20px 20px 0 0" : 0,
                    background: "#0f0e0fff",
                    flexDirection: 'column',
                    display: 'flex'
                }
            }}
        >
            <Box sx={{
                overflowY: "auto",
                display: 'flex',
                flexDirection: 'column',
                flex: 1
            }} >
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 1,
                    py: 2,
                    borderBottom: "1px solid #aaaaaa20"
                }}>
                    <IconButton onClick={onClose}>
                        <CloseRounded />
                    </IconButton>
                    <span style={{
                        fontSize: "14px",
                        fontFamily: "poppins-reg"
                    }}>{"New Noticeboard Slide"}</span>

                </Box>

                <Box sx={{ flexDirection: 'column', flex: 1, display: 'flex', overflow: 'scroll' }} >

                    <form onSubmit={handleSubmit} style={{ marginInline: "15px", marginTop: "10px" }} encType="multipart/form-data">

                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "10px",
                            marginBottom: "10px",
                            border: "1px solid #aaaaaa30",
                            background: "#000000"
                        }}>

                            <input placeholder="Noticeboard title..."
                                multiple={false}
                                value={formData.title}
                                name="title"
                                required
                                onChange={handleChange}
                                style={{
                                    outline: 'none',
                                    backgroundColor: "#aaaaaa00",
                                    borderWidth: 0,
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "12px",
                                    flex: 1,
                                    display: 'flex',
                                    fontSize: "14px",
                                    paddingBottom: "12px",
                                    fontFamily: 'poppins-reg',
                                    color: "white"
                                }} />


                        </Box>

                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            borderRadius: "10px",
                            border: "1px solid #aaaaaa30",
                            marginBottom: "10px",
                            background: "#000000"
                        }}>

                            <textarea placeholder="Enter description..."
                                rows={3}
                                value={formData.description}
                                required
                                name="description"
                                onChange={handleChange}
                                style={{
                                    outline: 'none',
                                    backgroundColor: "#aaaaaa00",
                                    borderWidth: 0,
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "12px",
                                    flex: 1,
                                    display: 'flex',
                                    fontSize: "14px",
                                    paddingBottom: "12px",
                                    fontFamily: 'poppins-reg',
                                    color: "white"
                                }} />


                        </Box>

                        <Box sx={{
                            flexDirection: 'row',
                            backgroundColor: "#ffffff10",
                            display: 'flex',
                            marginBottom: "10px",
                            borderRadius: "10px",
                            border: "1px solid #aaaaaa30",
                            background: "#000000"
                        }}>

                            <input placeholder="Slide position"
                                multiple={false}
                                value={formData.position}
                                name="position"
                                required
                                inputMode={'numeric'}
                                onChange={handleChange}
                                style={{
                                    outline: 'none',
                                    backgroundColor: "#aaaaaa00",
                                    borderWidth: 0,
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                    paddingTop: "12px",
                                    flex: 1,
                                    display: 'flex',
                                    fontSize: "14px",
                                    paddingBottom: "12px",
                                    fontFamily: 'poppins-reg',
                                    color: "white"
                                }} />


                        </Box>


                        <FormControl fullWidth required sx={{ marginBottom: "10px", }}>
                            <Select style={{
                                fontFamily: 'poppins-reg', fontSize: "14px",
                            }}

                                sx={{
                                    fontFamily: "poppins-reg",
                                    fontSize: 14,

                                    // HEIGHT / PADDING
                                    "& .MuiSelect-select": {
                                        padding: "13px 14px",
                                        background: "#000000",
                                        borderRadius: "10px",
                                    },

                                    // BORDER COLOR
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#aaaaaa30",
                                        borderRadius: "10px",
                                    },

                                    // HOVER
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#aaaaaa30",
                                    },

                                    // FOCUSED
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#aaaaaa30",
                                        borderWidth: "1px",
                                    },

                                    // TEXT COLOR
                                    color: "#ffffff",
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            bgcolor: "#000000",
                                            color: "#ffffff",
                                        }
                                    }
                                }} name="creator" placeholder="Select" value={formData.creator} onChange={handleChange} required>
                                {COMMUNITYADMINS.map((creator) => (
                                    <MenuItem key={creator.id} value={creator.id}>{creator.name}</MenuItem>
                                ))}
                            </Select>
                            {
                                !formData.creator && (
                                    <Box sx={{
                                        position: "absolute", width: "100%", height: "100%", display: "flex", justifyContent: "center", flexDirection: "column",
                                        paddingInline: "14px", pointerEvents: 'none'
                                    }}>

                                        <Typography style={{
                                            color: "#ffffff", fontFamily: "poppins-reg",
                                            fontSize: 14,
                                        }} >Select Creator</Typography>


                                    </Box>
                                )
                            }
                        </FormControl>



                        {/* Redirect Type (Inside/Outside) */}
                        <FormControl component="fieldset" sx={{ marginInline: "5px", marginBottom: "10px", }}>
                            <RadioGroup row={false} name="redirectType" value={formData.redirectType} onChange={handleChange}>
                                <FormControlLabel
                                    value="inside"
                                    control={<Radio sx={{
                                        color: "#ffffff90", // Default color
                                        "&.Mui-checked": {
                                            color: "white", // Selected color
                                        },
                                    }} />}
                                    label="Open Inside"
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: "14px", // Change font size
                                            fontFamily: "poppins-reg", // Change font family
                                            color: "#ffffff", // Change font color
                                        },
                                    }}
                                />
                                <FormControlLabel
                                    value="outside"
                                    control={<Radio sx={{
                                        color: "#ffffff90", // Default color
                                        "&.Mui-checked": {
                                            color: "white", // Selected color
                                        },
                                    }} />}
                                    label="Open Outside"
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: "14px",
                                            fontFamily: "poppins-reg",
                                            color: "#ffffff",
                                        },
                                    }}
                                />

                                <FormControlLabel
                                    value="none"
                                    control={<Radio sx={{
                                        color: "#ffffff90", // Default color
                                        "&.Mui-checked": {
                                            color: "white", // Selected color
                                        },
                                    }} />}
                                    label="Do nothing"
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: "14px",
                                            fontFamily: "poppins-reg",
                                            color: "#ffffff",
                                        },
                                    }}
                                />
                            </RadioGroup>
                        </FormControl>

                        {
                            formData.redirectType == "outside" && (

                                <Box sx={{
                                    flexDirection: 'row',
                                    backgroundColor: "#ffffff10",
                                    display: 'flex',
                                    marginBottom: "10px",
                                    borderRadius: "10px",
                                    border: "1px solid #aaaaaa30",
                                    background: "#000000"
                                }}>

                                    <input placeholder="Enter url to open"
                                        multiple={false}
                                        value={formData.redirectUrl}
                                        name="redirectUrl"
                                        required
                                        onChange={handleChange}
                                        style={{
                                            outline: 'none',
                                            backgroundColor: "#aaaaaa00",
                                            borderWidth: 0,
                                            paddingLeft: "15px",
                                            paddingRight: "15px",
                                            paddingTop: "12px",
                                            flex: 1,
                                            display: 'flex',
                                            fontSize: "14px",
                                            paddingBottom: "12px",
                                            fontFamily: 'poppins-reg',
                                            color: "white"
                                        }} />


                                </Box>

                            )
                        }

                        {
                            formData.redirectType == "inside" && (
                                <FormControl fullWidth required sx={{ marginBottom: "10px", }}>
                                    <Select style={{
                                        fontFamily: 'poppins-reg', fontSize: "14px",
                                    }}

                                        sx={{
                                            fontFamily: "poppins-reg",
                                            fontSize: 14,

                                            // HEIGHT / PADDING
                                            "& .MuiSelect-select": {
                                                padding: "13px 14px",
                                                background: "#000000",
                                                borderRadius: "10px",
                                            },

                                            // BORDER COLOR
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#aaaaaa30",
                                                borderRadius: "10px",
                                            },

                                            // HOVER
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#aaaaaa30",
                                            },

                                            // FOCUSED
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#aaaaaa30",
                                                borderWidth: "1px",
                                            },

                                            // TEXT COLOR
                                            color: "#ffffff",
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    bgcolor: "#000000",
                                                    color: "#ffffff",
                                                }
                                            }
                                        }} name="idType" placeholder="Select" value={formData.idType} onChange={handleChange} required>
                                        {["Event", "Post", "Product", "Collab", "Club", "Profile"].map((creator) => (
                                            <MenuItem key={creator} value={creator.toLowerCase()}>{creator} screen</MenuItem>
                                        ))}
                                    </Select>
                                    {
                                        !formData.idType && (
                                            <Box sx={{
                                                position: "absolute", width: "100%", height: "100%", display: "flex", justifyContent: "center", flexDirection: "column",
                                                paddingInline: "14px", pointerEvents: 'none'
                                            }}>

                                                <Typography style={{
                                                    color: "#ffffff", fontFamily: "poppins-reg",
                                                    fontSize: 14,
                                                }} >Select a screen to open</Typography>


                                            </Box>
                                        )
                                    }
                                </FormControl>
                            )
                        }

                        {
                            formData.redirectType == "inside" && (


                                <Box sx={{
                                    flexDirection: 'row',
                                    backgroundColor: "#ffffff10",
                                    display: 'flex',
                                    borderRadius: "10px",
                                    marginBottom: "10px",
                                    border: "1px solid #aaaaaa30",
                                    background: "#000000"
                                }}>

                                    <input placeholder={ formData.idType == "profile" ? "Enter username" : formData.idType == "club" ? "Enter club id" : "Enter public id"}
                                        multiple={false}
                                        value={formData.redirectId}
                                        name="redirectId"
                                        required
                                        onChange={handleChange}
                                        style={{
                                            outline: 'none',
                                            backgroundColor: "#aaaaaa00",
                                            borderWidth: 0,
                                            paddingLeft: "15px",
                                            paddingRight: "15px",
                                            paddingTop: "12px",
                                            flex: 1,
                                            display: 'flex',
                                            fontSize: "14px",
                                            paddingBottom: "12px",
                                            fontFamily: 'poppins-reg',
                                            color: "white"
                                        }} />


                                </Box>


                            )
                        }







                        {/* File Upload */}
                        <input type="file" accept="image/*" onChange={handleFileChange} required style={{ marginTop: "10px", fontFamily: "poppins-reg", marginInline: "5px" }} />



                        <FormControlLabel

                            control={
                                <Checkbox checked={notifyUsers} sx={{
                                    color: '#aaa',
                                    '&.Mui-checked': {
                                        color: '#4caf50', // your custom color when checked
                                    },
                                }} onChange={() => {
                                    setNotifyUsers(!notifyUsers)
                                }} />
                            }

                            sx={{
                                marginTop: "20px",
                                marginInline: "-5px",
                                marginBottom: "30px",
                                fontFamily: "poppins-reg",
                                ".MuiFormControlLabel-label": {
                                    fontFamily: "poppins-reg",
                                    fontSize: 13,
                                    lineHeight: "20px",
                                    color: "#ddd",
                                    display: "flex",
                                    alignItems: "center"
                                }
                            }}
                            label="Send notification"
                        />
                    </form>
                </Box>

                <Box onClick={() => {

                    if (!formData.title || !formData.description || !formData.position || !formData.creator ||
                        !formData.redirectType ||
                        (formData.redirectType == "outside" && !formData.redirectUrl) ||
                        (formData.redirectType == "inside" && (!formData.idType || !formData.redirectId)) || !formData.mediaUrl || !formData.mediaUrl.name) {
                        alert("Please enter all the required fields")
                    } else {
                        handleSubmit()
                    }

                }} sx={{
                    background: "#943bff", borderRadius: "100px", marginInline: "15px", marginBottom: "20px",
                    display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBlock: "13px",
                    userSelect: 'none', cursor: 'pointer'
                }}>
                    {
                        loading ? (
                            <Box sx={{ display: 'flex', alignSelf: 'center', marginBlock: "2px" }}>
                                <ClipLoader size={"18px"} color={"#ffffff"} />
                            </Box>
                        ) : (
                            <Typography sx={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff" }} >Create</Typography>
                        )
                    }

                </Box>


            </Box>

        </Drawer >
    );
};

export default MultiPartFormPopup;
